import { Injectable } from '@angular/core'
import { ModalPositionService } from '@helios/user-preferences'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { HotkeysHelpComponent } from './hotkeys-help.component'

/** Service for showing and hiding the hotkeys help modal. */
@Injectable({
  providedIn: 'root',
})
export class HotkeysHelpService {
  private activeModal: NgbModalRef | null = null

  constructor(
    private readonly modalService: NgbModal,
    readonly modalPositionService: ModalPositionService,
  ) {}

  /** Show/Hide the hotkeys help modal. */
  toggleHotkeysHelp() {
    if (this.activeModal == null) {
      const compKey = 'hot-keys-help'
      const uniqueId = compKey + '-' + Date.now()
      this.activeModal = this.modalService.open(HotkeysHelpComponent, {
        keyboard: false,
        windowClass: uniqueId,
        beforeDismiss: () => {
          return this.modalPositionService.handleModalPositionSaveOnDismiss(
            uniqueId,
            compKey,
          )
        },
      })
      this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)
      this.activeModal.result
        .then(() => (this.activeModal = null))
        .catch(() => (this.activeModal = null))
    } else {
      this.activeModal?.close()
      this.activeModal = null
    }
  }
}
